import { render, staticRenderFns } from "./CcManagement.vue?vue&type=template&id=e20f873a&"
import script from "./CcManagement.vue?vue&type=script&lang=js&"
export * from "./CcManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports